"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DiagnosticButtons = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _useOurTranslation = require("../../utils/useOurTranslation");

var _IntroText = _interopRequireDefault(require("../IntroText"));

var _Button = _interopRequireDefault(require("@jobmatchme/ui/es/components/styleguide/Button"));

var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));

var _Section = _interopRequireDefault(require("@jobmatchme/ui/es/components/Section"));

var _Optimizers = require("../../utils/Optimizers");

var _Funnel = require("../Funnel");

var _styleModule = _interopRequireDefault(require("./style.module.scss"));

var _ProfileProvider = require("../../provider/ProfileProvider");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 * DiagnosticButtons component for whitelabel registration funnel
 * @param {*} param0
 */
var DiagnosticButtonsComponent = function DiagnosticButtonsComponent(_ref) {
  var config = _ref.config,
      context = _ref.context;
  var t = (0, _useOurTranslation.useComponentTranslation)(config);

  var _useFunnelActions = (0, _Funnel.useFunnelActions)(),
      next = _useFunnelActions.next;

  var _useContext = (0, _react.useContext)(_ProfileProvider.ProfileActionsContext),
      setValue = _useContext.setValue;

  var startAnswerTime = new Date().getTime();

  var _useState = (0, _react.useState)({}),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      currentValue = _useState2[0],
      setCurrentValue = _useState2[1];

  var handleClick = function handleClick(value) {
    var payload = {
      name: config.identifier,
      value: value ? String(value) : value,
      responseTime: new Date().getTime() - startAnswerTime,
      position: null
    };
    setValue(config.valueName, payload);
    setTimeout(function () {
      next();
    }, 200);
  };

  (0, _react.useEffect)(function () {
    var value = context[config.valueName].value.filter(function (element) {
      return element.name === config.identifier;
    });
    setCurrentValue(value.length > 0 ? value[0] : {});
  }, [context, config]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: _styleModule.default.DiagnosticButtons,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_IntroText.default, {
      headline: t(config.translations.text)
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Section.default, {
      className: _styleModule.default.contactForm,
      noPaddingBottom: true,
      noPaddingTop: true,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
        container: true,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
          item: true,
          xs: 12,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
            container: true,
            children: Object.entries(config.options).map(function (_ref2) {
              var _ref3 = (0, _slicedToArray2.default)(_ref2, 2),
                  option = _ref3[0],
                  translation = _ref3[1];

              return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
                item: true,
                xs: 12,
                className: _styleModule.default.formCol,
                children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                  children: [' ', /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
                    id: "".concat(config.valueName, "_button-bc-landingpage_").concat(option),
                    variant: "contained",
                    onClick: function onClick() {
                      return handleClick(option);
                    },
                    className: "".concat(_styleModule.default.button, " ").concat(currentValue && currentValue.value === option ? _styleModule.default.active : ''),
                    round: true,
                    flat: true,
                    bold: true,
                    children: t(translation)
                  })]
                }, "".concat(config.valueName, "_").concat(option))
              });
            })
          })
        })
      })
    })]
  });
};

var DiagnosticButtonsWrapper = (0, _Optimizers.memoizeComponentByValue)(DiagnosticButtonsComponent);

var DiagnosticButtons = function DiagnosticButtons(_ref4) {
  var config = _ref4.config;
  var context = (0, _react.useContext)(_ProfileProvider.ProfileContext);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(DiagnosticButtonsWrapper, {
    config: config,
    context: context
  });
};

exports.DiagnosticButtons = DiagnosticButtons;